import React from 'react'
import './FileExplorer.css'

// This object is a basic file explorer UI used to see and manage the files stores on the public/media directory on the server.
// This object is automatically displayed by the MediaModule.
export default class FileExplorer extends React.Component {
  state = {
    mediaModuleSelected: null,// the Module that is displaying this object.
    currentDIR: [],
    files: [],
    fileItemList: [],
    selectedFiles: [],
    userPassword: "",
  }

  constructor(props) {
    super();
    this.state.mediaModuleSelected = props.module;
    let pathArray = props.dir.split("/");
    pathArray = pathArray.slice(0, pathArray.length - 1);
    if (pathArray.length == 0) { pathArray.push("media"); }
    this.state.currentDIR = pathArray;
    this.getFiles();
    this.state.userPassword = props.password;
  }

  //Makes a call to the server to see what files are in the current directory.
  getFiles() {
    fetch("/api/getFiles/path/" + this.arrayToURLParameters(this.state.currentDIR))
      .then((res) => res.json())
      .then((jsonData) => {
        this.setState({ files: jsonData });
        this.createFileItemList(jsonData);
      });
  }

  //Converts an array of folder names into a string directory with slashes separating each folder.
  arrayToURL(array) {
    let url = "";
    array.forEach(folder => {
      url += folder + "/";
    });
    return url;
  }

  //Converts an array of folder names into a string directory with %2F separating each folder (to be used as URL parameter).
  arrayToURLParameters(array) {
    let url = "";
    array.forEach(folder => {
      url += folder + "%2F";
    });
    return url;
  }
  //Takes in the URL array (currentDIR) and outputs HTML text with clickable links to swap DIR.
  arrayToURLLinks(array) {
    let url = [];
    for (let i = 0; i < array.length - 1; i++) {
      url[i] = <a> <span className="link" onClick={() => this.directoryBack(i)}>{array[i]}</span> / </a>;
    };
    url[array.length - 1] = <a>{array[array.length - 1]}</a>;
    return url;
  }

  //Click handler for clicking on files
  clickHandler(event, fileName) {
    //If shift is pressed, enter multi-select mode.
    if (event.shiftKey) {
      //if already selected, unselect
      if (document.getElementById("f:" + fileName).classList.contains("selected")) {
        document.getElementById("f:" + fileName).classList.remove("selected");
        const index = this.state.selectedFiles.indexOf(fileName);
        let newSelectedList = this.state.selectedFiles;
        newSelectedList.splice(index, 1);
        this.setState({ selectedFiles: newSelectedList });
      }
      //add to selection
      else {
        document.getElementById("f:" + fileName).classList.add("selected");
        let newSelectedList = this.state.selectedFiles;
        newSelectedList.push(fileName);
        this.setState({ selectedFiles: newSelectedList });
      }
    }
    //If no shift, leave only tis file selected
    else {
      Array.from(document.getElementsByClassName("fileItem")).forEach((fileItem) => fileItem.classList.remove("selected"));
      this.setState({ selectedFiles: [fileName] });
      document.getElementById("f:" + fileName).classList.add("selected");
    }
  }

  //Double clicking on an item.
  doubleClickHandler(fileName) {
    if (fileName.includes(".")) {//If it's a file, select it and "chose".
      Array.from(document.getElementsByClassName("fileItem")).forEach((fileItem) => fileItem.classList.remove("selected"));
      this.setState({ selectedFiles: [fileName] });
      document.getElementById("f:" + fileName).classList.add("selected");
      this.chooseHandler();
    }
    else {//If a folder, enter that directory.
      this.enterDirectory(fileName);
      Array.from(document.getElementsByClassName("fileItem")).forEach((fileItem) => fileItem.classList.remove("selected"));
      this.setState({ selectedFiles: [] });
    }
  }

  keyDownHandler(event) {
    if (event.shiftKey && event.key === 'n' || event.key === 'N') {
      this.addFolderHandler();
    }
    else if (event.shiftKey && event.key === 'r' || event.key === 'R') {
      this.renameHandler();
    }
    else if (event.shiftKey && event.key === 'd' || event.key === 'D') {
      this.deleteHandler();
    }
  }

  enterDirectory(fileName) {
    this.setState({ currentDIR: [...this.state.currentDIR, fileName] }, this.getFiles);

  }

  //Return one directory
  directoryBack(index) {
    if (this.state.currentDIR.length == 1) { return; }
    if (index || index == 0) {
      this.setState({ currentDIR: this.state.currentDIR.slice(0, index + 1) }, this.getFiles);
    }
    else {
      this.setState({ currentDIR: this.state.currentDIR.slice(0, -1) }, this.getFiles);
    }
  }

  //Calls fileItem() on all files passed in.
  createFileItemList(files) {
    this.setState({ fileItemList: files.map((file) => this.fileItem(file)) });
  }

  //Takes in a file and creates the HTML element (thumbnail + filename) to display
  fileItem(fileName) {
    return <div className="fileItem" id={"f:" + fileName} onClick={(event) => this.clickHandler(event, fileName)} onDoubleClick={() => this.doubleClickHandler(fileName)}>
      {fileName.split('.').pop().toLowerCase() == ("pdf") ? <img src={"icons/pdf.png"} draggable={false} /> :
        fileName.split('.').pop().toLowerCase() == ("mp4") ? <img src={"icons/video.png"} draggable={false} /> :
          fileName.includes(".") ? <img src={this.arrayToURL(this.state.currentDIR) + fileName} draggable={false} /> :
            !this.canEditFolder(this.state.currentDIR, fileName) ? <img src="icons/folder_yellow.png" draggable={false} /> : <img src="icons/folder.png" draggable={false} />}
      {fileName}
    </div>
  }

  showUploadForm() {
    document.getElementById("showUploadFormButton").style.display = "none";
    document.getElementById("uploadForm").style.display = "block";
  }

  hideUploadForm() {
    document.getElementById("uploadForm").reset();
    document.getElementById("showUploadFormButton").style.display = "block";
    document.getElementById("uploadForm").style.display = "none";
  }

  uploadFiles() {
    let fileData = new FormData(document.getElementById("uploadForm"));
    fileData.append("dir", this.arrayToURL(this.state.currentDIR));
    fileData.append("password", this.state.userPassword);

    //Reset upload UI
    this.hideUploadForm();

    fetch("/api/uploadFiles", { method: "POST", body: fileData })
      .then((res) => {
        this.getFiles();
        if (res.status == 401) {//Wrong password
          alert("Log-in failed :(\nPlease log in again.");
        }
      });
  }

  dropFile(event) {
    event.preventDefault();
    document.getElementById("fileExplorer").classList.remove("uploadFileDrag");

    //Filtering out invalid files
    const receivedFiles = event.dataTransfer.files;
    let acceptedFiles = new DataTransfer();

    for (let i = 0; i < receivedFiles.length; i++) {
      if (receivedFiles[i].type.includes("image/") || receivedFiles[i].type == ("video/mp4") || receivedFiles[i].type.includes("application/pdf")) {
        acceptedFiles.items.add(receivedFiles[i]);
      }
    }

    this.showUploadForm();
    document.getElementById("fileSelector").files = acceptedFiles.files;
  }

  dragOver(event) {
    event.preventDefault();
    document.getElementById("fileExplorer").classList.add("uploadFileDrag");
  }

  dragLeave(event) {
    document.getElementById("fileExplorer").classList.remove("uploadFileDrag");
  }

  // Returns false if a folder can't be deleted or renamed
  canEditFolder(dir, folderName) {
    if (folderName == "Banners" && dir == "media") {
      return false
    }
    return true
  }

  //Rename button handler
  renameHandler() {
    if (this.state.selectedFiles.length != 1) {
      alert("Please select one file to rename.");
      return;
    }
    const selectedFileName = this.state.selectedFiles[0];
    let newName = prompt("Name your file", selectedFileName);

    if (!this.canEditFolder(this.state.currentDIR, selectedFileName)) {
      alert("This is a permanent folder.\nPermanent folders cannot be renamed!")
      return;
    }

    if (newName && selectedFileName != newName) {
      //Unless the user specifies a new file extension, the same extension is preserved.
      const lastPeriodIndex = selectedFileName.lastIndexOf('.');
      let originalExtension = "";
      if (lastPeriodIndex !== -1) { // If the original file has an extension
        originalExtension = selectedFileName.substring(lastPeriodIndex + 1);//isolate the extension type
        if (newName.lastIndexOf('.') == -1) {//if the new name does not have an extension, add one.
          newName += "." + originalExtension;
        }
      }

      //Server call
      fetch("/api/renameFile", { method: "POST", body: JSON.stringify({ dir: this.arrayToURL(this.state.currentDIR), oldName: selectedFileName, newName: newName, password: this.state.userPassword }), headers: { "Content-type": "application/json; charset=UTF-8" } })
        .then((res) => {
          this.getFiles();
          if (res.status == 401) {//Wrong password
            alert("Log-in failed :(\nPlease log in again.");
          }
          else if (res.status == 400) {
            alert("Unknown error :/");
          }
        });
    }
  }

  //Delete button handler
  deleteHandler() {
    for (let i = 0; i < this.state.selectedFiles.length; i++) {
      if (!this.canEditFolder(this.state.currentDIR, this.state.selectedFiles[i])) {
        alert("One of these is a permanent folder.\nPermanent folders cannot be deleted!")
        return;
      }
    }
    if (this.state.selectedFiles.length > 0 && window.confirm("Permanently delete " + this.state.selectedFiles.length + " item(s)?\n(Files inside deleted folders are also erased)")) {
      //server call
      fetch("/api/deleteFiles", { method: "POST", body: JSON.stringify({ dir: this.arrayToURL(this.state.currentDIR), files: this.state.selectedFiles, password: this.state.userPassword }), headers: { "Content-type": "application/json; charset=UTF-8" } })
        .then((res) => {
          this.getFiles();
          //clear state.selectedFiles
          Array.from(document.getElementsByClassName("fileItem")).forEach((fileItem) => fileItem.classList.remove("selected"));
          this.setState({ selectedFiles: [] });
          if (res.status == 401) {//Wrong password
            alert("Log-in failed :(\nPlease log in again.");
          }
          else if (res.status == 400) {
            alert("Unknown error :/");
          }
        });
    }
  }

  //Add Folder button handler
  addFolderHandler() {
    const folderName = prompt("Name your folder", "New_Folder");
    if (!folderName) {
      return;
    }
    //server call
    fetch("/api/addFolder", { method: "POST", body: JSON.stringify({ dir: this.arrayToURL(this.state.currentDIR), name: folderName, password: this.state.userPassword }), headers: { "Content-type": "application/json; charset=UTF-8" } })
      .then((res) => {
        this.getFiles();
        if (res.status == 401) {//Wrong password
          alert("Log-in failed :(\nPlease log in again.");
        }
        else if (res.status == 400) {
          alert("Unknown error :/");
        }
      });
  }

  //Choose button handler
  chooseHandler() {
    if (this.state.selectedFiles.length != 1) {
      alert("Please select one file.");
      return;
    }

    const selectedFileName = this.state.selectedFiles[0];
    if (selectedFileName.includes(".")) {//If chose a file, close explorer.
      this.state.mediaModuleSelected.endExplorerMode(this.arrayToURL(this.state.currentDIR) + selectedFileName);
    }
    else {//If chose a folder, open it.
      this.enterDirectory(selectedFileName);
    }
  }

  //Download handler
  downloadHandler() {
    if (this.state.selectedFiles.length > 0) {
      let queryParameter = "?";
      this.state.selectedFiles.forEach(file => {
        queryParameter += "file=" + file + "&";
      });
      queryParameter += "DIR=" + this.arrayToURL(this.state.currentDIR);
      //GET request to download files from the server.
      window.open("api/downloadFiles" + queryParameter);
      alert("Downloading...");
    }
  }

  //Copy link button handler
  copyLinkHandler() {
    if (this.state.selectedFiles.length != 1) {
      alert("Please select one file.");
      return;
    }

    const selectedFileName = this.state.selectedFiles[0];
    navigator.clipboard.writeText("ewb.wpi.edu/" + this.arrayToURL(this.state.currentDIR) + selectedFileName);
  }

  render() {
    return (
      <div className="overlay">
        <div className="fileExplorer" id="fileExplorer" tabindex="0" onKeyDown={(event) => this.keyDownHandler(event)} onDragOver={(event) => this.dragOver(event)} onDragLeave={(event) => this.dragLeave(event)}>
          <div className="addressBar">
            <img className="barButton" onClick={() => this.directoryBack()} width="15px" src="icons/arrow.png" />
            <p>{this.arrayToURLLinks(this.state.currentDIR)}</p>
          </div>
          <div className="fileContainerSpacer" onDrop={(event) => this.dropFile(event)}>
            <div className="fileContainer">
              {this.state.fileItemList}
            </div>
          </div>
          <div className="bottomControls">
            <button id="showUploadFormButton" className="uploadButton" onClick={() => this.showUploadForm()}><img height="15px" src="icons/upload.png" /> Upload</button>

            <form id="uploadForm" className="uploadForm" onSubmit={() => this.uploadFiles()} target="hiddenFrame" >
              <button type="submit" className="uploadButton"><img height="15px" src="icons/upload.png" /> Upload</button>
              <input name="files" id="fileSelector" type="file" accept="image/*, video/MP4, application/pdf" multiple />
            </form>

            <button className="green" onClick={() => this.chooseHandler()}><img height="15px" src="icons/select.png" /> Choose</button>
            <button className="grey" onClick={() => this.renameHandler()}><img height="15px" src="icons/rename.png" /> Rename</button>
            <button className="red" onClick={() => this.deleteHandler()}><img height="15px" src="icons/trash.png" /> Delete</button>
            <button className="blue" onClick={() => this.addFolderHandler()}><img height="15px" src="icons/move.png" /> Add Folder</button>
            <button className="" onClick={() => this.downloadHandler()}><img height="15px" src="icons/download.png" /> Download</button>
            <button className="" onClick={() => this.copyLinkHandler()}><img height="15px" src="icons/link.png" /> Copy Link</button>
          </div>
        </div>
        <div>
          <button className="closeControls" onClick={() => this.state.mediaModuleSelected.endExplorerMode(null)}>Close</button>
        </div>
        <iframe name="hiddenFrame" width="0" height="0" border="0" hidden></iframe>
      </div>
    )
  }
}